import { render, staticRenderFns } from "./dropdownSubMenu.vue?vue&type=template&id=27e72478&"
import script from "./dropdownSubMenu.vue?vue&type=script&lang=js&"
export * from "./dropdownSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./dropdownSubMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports